import { ChangePasswordCard } from "@features/profile/components/change-password-card";
import { DangerZoneCard } from "@features/profile/components/danger-zone-card";
import ProfileHeader from "@features/profile/components/profile-header";
import { SessionsCard } from "@features/profile/components/session-card";
import { useIntl } from "react-intl";

export default function SecurityPage() {
	const intl = useIntl();

	return (
		<div className="space-y-6">
			<ProfileHeader
				title={intl.formatMessage({
					id: "page.profile.security.title",
					defaultMessage: "Security",
				})}
				description={intl.formatMessage({
					id: "page.profile.security.subTitle",
					defaultMessage: "Account security actions and events",
				})}
			/>
			<ChangePasswordCard />
			<SessionsCard />
			<DangerZoneCard />
		</div>
	);
}
